var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSheetMetal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m372.94 682.18c-28.887-3.7969-53.594 15.602-53.594 61.555-0.29297 63.246 45.176 139.92 98.445 170.66 50.344 29.051 86.898 6.9766 86.898-49.754 0.36719-80.961-71.926-174.93-131.75-182.46zm38.953 171.89c-23.859-13.777-43.227-47.316-43.148-74.734 0.078125-27.418 19.57-38.43 43.43-24.652 23.945 13.824 43.141 47.172 43.062 74.59-0.078125 27.418-19.398 38.625-43.344 24.797z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m297.05 768.03c-5.3359-38.414 0.95703-81.438 33.902-101.24 18.793-11.324 373.27-217.14 558.89-325.05l-116.14-67.297c-3.75-2.1719-8.3789-2.168-12.121 0.011719l-698.99 407.04c-7.9414 4.625-8.0078 16.074-0.11719 20.789l271.88 162.42c-18.691-28.793-32.281-61.754-37.309-96.668z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1044.9 323.43c-24.371-14.094-46.664-16.699-62.691-7.4492-61.383 35.688 220.32-128.1-593.07 344.82 81.77 22.527 157.58 148.78 136.05 234.89l593.43-344.98c15.672-9.2031 24.465-29.566 24.723-57.305 0-62.43-44.164-138.73-98.445-169.97z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSheetMetal);
export default __webpack_public_path__ + "static/media/sheet_metal.eee8bda663253a5121634f0c8a6ac601.svg";
export { ForwardRef as ReactComponent };